import React, { ChangeEvent, forwardRef, useState } from "react";

import styles from "./BarcodeInput.module.css";
import { Input, StrictInputProps } from "semantic-ui-react";
import classNames from "classnames";
import useInput from "../../../hooks/useInput";

interface Props extends StrictInputProps {
  placeholder?: string;
  onValidate?: (value: string) => boolean;
  onBarcodeScan: (value: string) => void;
  clearValueOnSuccess?: boolean;
}

const BarcodeInput = forwardRef(
  (
    { disabled, placeholder, onValidate, onBarcodeScan, clearValueOnSuccess, ...props }: Props,
    ref
  ) => {
    const {
      currentValue: barcode,
      isValid,
      hasError,
      onChangeHandler,
      onEnterHandler,
      inputReset,
    } = useInput({
      onValidate,
      onSuccess: () => {
        if (clearValueOnSuccess) inputReset();
        onBarcodeScan(barcode);
      },
    });

    const onKeyDownHandler = async (e: React.KeyboardEvent<any>) => {
      if (!["Tab", "Enter"].includes(e.key)) return;
      e.preventDefault();
      onEnterHandler();
    };

    const classes = classNames([
      styles["barcode-input"],
      { [styles["done"]]: isValid, [styles["progressive"]]: false },
    ]);

    return (
      <Input
        size="big"
        className={classes}
        autoComplete="off"
        id="ScanInputField"
        autoFocus
        ref={ref as any}
        disabled={disabled} // || success
        placeholder={placeholder}
        value={barcode}
        onChange={onChangeHandler}
        onKeyDown={onKeyDownHandler}
        error={hasError}
        {...props}
      />
    );
  }
);

export default BarcodeInput;
